import React, { useState, useEffect } from "react";
import { getAuthHeader } from "../../api/authToken.js";
import "../../styles/App.css";
import { NO_GROUP_TEXT } from "../../components/GroupLabel.js";

const ProposeAct = () => {
  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStudent, setSelectedStudent] = useState("");
  const [date, setDate] = useState("");
  const [reason, setReason] = useState("");
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const API = process.env.REACT_APP_API_BASE;


  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const response = await fetch(`${API}/api/students`, {
          headers: { Authorization: getAuthHeader() },
        });
        const data = await response.json();
        setStudents(data);
        setFilteredStudents(data); 
      } catch (error) {
        console.error("Помилка завантаження студентів:", error);
      }
    };

    fetchStudents();
  }, []);

  useEffect(() => {
    const filtered = students.filter((student) =>
      student.pib.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredStudents(filtered);
  }, [searchTerm, students]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("student_id", selectedStudent);
    formData.append("date", date);
    formData.append("reason", reason);
    if (file) formData.append("file", file); 

    try {
      const response = await fetch(`${API}/api/propose-act`, {
        method: "POST",
        body: formData,
        headers: { Authorization: getAuthHeader() },
      });

      const data = await response.json();
      setMessage(data.message);
      setSelectedStudent("");
      setDate("");
      setReason("");
      setFile(null);
      setSearchTerm(""); 
    } catch (error) {
      console.error("Помилка надсилання акту:", error);
      setMessage("Помилка під час відправки");
    }
  };

  return (
    <div className="page-container">
      <h2 className="header-content-title">Запропонувати акт</h2>
      {message && <p>{message}</p>}
      <form onSubmit={handleSubmit}>
        <div className="form-container">
          <div className="input-block text-header">
            Студент:
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Введіть ПІБ студента"
              className="input-component"
            />
            <select
              value={selectedStudent}
              onChange={(e) => setSelectedStudent(e.target.value)}
              required
              className="input-component"
            >
              <option value="" disabled>
                Оберіть студента
              </option>
              {filteredStudents.map((student) => (
                <option key={student.id} value={student.id}>
                  {student.pib} ({student.group || NO_GROUP_TEXT})
                </option>
              ))}
            </select>
          </div>
          <div className="input-block">
            <p className="text-header">Дата порушення:</p>
            <input
              className="input-component"
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              required
              style={{
                width: "100%",
              }}
            />
          </div>
        </div>

        <div>
          <p className="text-header">Причина порушення: </p>
          <textarea
            className="input-component"
            placeholder="Введіть причину порушення"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            required
            style={{
              width: "100%",
              minHeight: "50px",
            }}
          />
        </div>

        <div>
          <p className="text-header">Завантаження акту (необов’язково):</p>
          <input
            type="file"
            onChange={(e) => setFile(e.target.files[0])}
            className="input-component"
            style={{
              width: "100%",
            }}
          />
        </div>
        <button className="submit-button" type="submit">
          Запропонувати акт
        </button>
      </form>
    </div>
  );
};

export default ProposeAct;
